import { getAllBookingsPages, navigateToPage } from './editor-sdk-actions';

export async function navigateToBookingsList(sdk, appToken) {
  const bookingsPages = await getAllBookingsPages(sdk, appToken);
  const bookingsListPageRef = bookingsPages.find(
    (page) => page.tpaPageId === 'bookings_list',
  );
  return navigateToPage(sdk, appToken, bookingsListPageRef.id);
}
